export type Logger = {
  debug: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
};

export const createLogger = (enabled?: boolean): Logger => ({
  debug: (...args) => {
    if (enabled) console.debug("[StartButton-Payment-Gateway]", ...args);
  },
  warn: (...args) => {
    if (enabled) console.warn("[StartButton-Payment-Gateway]", ...args);
  }
});
